export const getZoneLabel = (index: number | string) => `ZONE ${index}`;
